import React from 'react';
import { createComboboxList, createOptionsList } from '../../../services/common/miscUtils';
import { getFormattedTodaysDate, getMinBirthDate } from '../../../services/common/validation';
import { EmploymentStatusEnum } from '../../../types/employmentStatusEnum';
import { OccupationEnum } from '../../../types/occupationEnum';
import { DatePickerFormField } from '../../Fieldset/DatePickerFormField';
import { EircodeFormField } from '../../Fieldset/EircodeFormField';
import { NumericInputFormField } from '../../Fieldset/NumericInputFormField';
import { SearchableSelectFormField } from '../../Fieldset/SearchableSelectFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { AddressSearchFormField } from '../../Fieldset/AddressSearchFormField';
import { CountyEnum } from '../../../types/countyEnum';

export const createFormInputs = () => {
  return {
    employmentStatus: () => (
      <SelectFormField
        fieldName="employmentStatus"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.employmentStatus.label"
        optionList={createOptionsList(
          EmploymentStatusEnum,
          'employmentDetailsForm',
          'employmentStatus',
          'currentEmploymentDetailsForm'
        )}
      />
    ),
    occupation: (isDisabled: boolean) => (
      <SearchableSelectFormField
        fieldName="occupation"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.occupation.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.occupation.placeholder"
        optionList={createComboboxList(OccupationEnum, 'employmentDetailsForm', 'occupation')}
        isDisabled={isDisabled}
      />
    ),
    employer: () => (
      <TextInputFormField
        fieldName="employer"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.employer.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.employer.placeholder"
      />
    ),
    occupationNotes: () => (
      <TextInputFormField
        fieldName="occupationNotes"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.occupationNotes.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.occupationNotes.placeholder"
      />
    ),
    searchAddress: () => <AddressSearchFormField />,
    addressLine1: () => (
      <TextInputFormField
        fieldName="addressLine1"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine1.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine1.placeholder"
      />
    ),
    addressLine2: () => (
      <TextInputFormField
        fieldName="addressLine2"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine2.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine2.placeholder"
      />
    ),
    addressLine3: () => (
      <TextInputFormField
        fieldName="addressLine3"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine3.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.addressLine3.label"
      />
    ),
    eirCode: () => (
      <EircodeFormField
        fieldName="eirCode"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.eirCode.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.eirCode.label"
      />
    ),
    town: () => (
      <TextInputFormField
        fieldName="town"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.town.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.town.label"
      />
    ),
    county: () => (
      <SelectFormField
        fieldName="county"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.county.label"
        optionList={createOptionsList(CountyEnum, 'employmentDetailsForm', 'county', 'currentEmploymentDetailsForm')}
      />
    ),
    timeWithEmployerFrom: (timeWithEmployerTo: string) => (
      <DatePickerFormField
        fieldName="timeWithEmployerFrom"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.timeWithEmployerFrom.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.timeWithEmployerTo.placeholder"
        minDate={getMinBirthDate()}
        maxDate={timeWithEmployerTo || new Date()}
      />
    ),
    timeWithEmployerTo: () => (
      <DatePickerFormField
        fieldName="timeWithEmployerTo"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.timeWithEmployerTo.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.timeWithEmployerTo.placeholder"
        maxDate={getFormattedTodaysDate()}
      />
    ),
    netMonthlyIncome: () => (
      <NumericInputFormField
        fieldName="netMonthlyIncome"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.netMonthlyIncome.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.netMonthlyIncome.placeholder"
        type="money"
        maximumFractionDigits={2}
      />
    ),
    netOtherMonthlyIncome: () => (
      <NumericInputFormField
        fieldName="netOtherMonthlyIncome"
        labelTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.netOtherMonthlyIncome.label"
        placeholderTranslationKey="employmentDetailsForm:currentEmploymentDetailsForm.netOtherMonthlyIncome.placeholder"
        type="money"
        maximumFractionDigits={2}
      />
    ),
  };
};
